import { MoreFiltersTypeEnum } from 'app/shared/enums';

export const moreFiltersGTMOptions = new Map<MoreFiltersTypeEnum, string>([
  [MoreFiltersTypeEnum.SubstituteCar, 'assistance_samochod_zastepczy'],
  [MoreFiltersTypeEnum.Amortization, 'ac_amortyzacja'],
  [MoreFiltersTypeEnum.AssistanceAfterFailure, 'assistance_po_awarii'],
  [MoreFiltersTypeEnum.ExcessType, 'ac_udzial_wlasny'],
  [MoreFiltersTypeEnum.FormOfRepair, 'ac_forma_naprawy'],
]);
